/**
 * @generated SignedSource<<1059ad1b58603584d56058ffc1f55e08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignedActorCompact_actor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SignedActorCompactBadge_actor" | "SignedActorText_actor">;
  readonly " $fragmentType": "SignedActorCompact_actor";
};
export type SignedActorCompact_actor$key = {
  readonly " $data"?: SignedActorCompact_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignedActorCompact_actor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignedActorCompact_actor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignedActorText_actor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignedActorCompactBadge_actor"
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "264c1f647120d85c4b5c2fb751845969";

export default node;
